import { GoogleApiWrapper } from "google-maps-react";

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GEOCODE_API_KEY,
});
